/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Map from 'routes/games/components/common/Map/Map';
import { TOI_IMAGE_DOMAIN } from 'constants';
import Cookie from 'utils/cookies';
import s from './GameOverlay.scss';
import HowToPlay from '../HowToPlay/HowToPlay';
// import LeaderBoard from '../LeaderBoard/LeaderBoard';
import LoginPrompt from '../LoginPrompt/LoginPrompt';
import GameSolution from '../GameSolution/GameSolution';

const GameOverlay = ({
  popUpType = '',
  gameId = '',
  gameType = '',
  gameOverlayCallback = () => {},
  callonContinue = () => {},
  onTextBoxChange = () => {},
  onTextBoxSubmit = () => {},
  textValue = '',
  apiConfigData = '',
  gameSubmitCallback = () => {},
  submitGuessCallback = () => {},
  mapData = '',
  maxGuessAllowed = '',
  onSubmitLocationGuesser = () => {},
  isMobile = false,
  errorCallback = () => {},
  isAppView = false,
  gameLevel = '',
  commonTranslations,
  gameSpecificTranslations,
  isGameIframe,
  iframeSource,
  isWebView,
  theme,
  failedAPI = '',
  calendarData,
  onCalendarNavigation,
  onLevelChange,
  showLoader,
  buttonClicked,
  gamejsonUrl,
  openLoginBox = () => {},
}) => {
  const [isOpen, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [doNotShowAgain, setDoNotShowAgain] = useState(true);
  const [doNotShowReset, setDoNotShowReset] = useState(true);
  const [isCheckedCW, setIsCheckedCW] = useState(true);
  const [isCheckedCWReset, setIsCheckedCWReset] = useState(true);
  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';

  const isClosedRef = useRef(false);

  // eslint-disable-next-line no-unused-vars
  const loaderCallBack = val => {
    setIsLoading(val);
  };

  const handlePreviousMonth = () => {
    if (typeof onCalendarNavigation === 'function') {
      onCalendarNavigation('previous');
    }
  };

  const handleNextMonth = () => {
    if (typeof onCalendarNavigation === 'function') {
      onCalendarNavigation('next');
    }
  };

  // Check if previous button should be disabled
  const isPreviousDisabled = () => {
    if (!calendarData?.playMoreData) return false;

    const startMonth = calendarData.playMoreData.calendarStartMonth;
    const startYear = calendarData.playMoreData.calendarStartYear;
    const currentMonth = calendarData.currentMonth || new Date().getMonth() + 1;
    const currentYear = calendarData.currentYear || new Date().getFullYear();

    // Disable if current month/year is at or before start month/year
    if (currentYear < startYear) return true;
    if (currentYear === startYear && currentMonth <= startMonth) return true;

    return false;
  };

  // Check if next button should be disabled
  const isNextDisabled = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11
    const currentYear = currentDate.getFullYear();

    const calendarMonth = calendarData?.currentMonth || currentMonth;
    const calendarYear = calendarData?.currentYear || currentYear;

    // Disable if calendar month/year is at or after current month/year
    if (calendarYear > currentYear) return true;
    if (calendarYear === currentYear && calendarMonth >= currentMonth)
      return true;

    return false;
  };

  const closePopup = (closeCase = '') => {
    if (isClosedRef.current) return;
    isClosedRef.current = true;
    try {
      const body = document.querySelector('body');
      body.classList.remove(s.modal_open);
    } catch (err) {
      throw err;
    }
    setOpen(false);
    gameOverlayCallback(closeCase);
  };

  const closePopupHowtoPay = type => {
    try {
      const body = document.querySelector('body');
      body.classList.remove(s.modal_open);
      setOpen(false);
      gameOverlayCallback();
      if (typeof localStorage !== 'undefined') {
        let storedValue;
        if (isGameIframe && iframeSource) {
          storedValue = localStorage.getItem(`${iframeSource}games`);
        } else {
          storedValue = localStorage.getItem('toigames');
        }
        const parsedValue = storedValue ? JSON.parse(storedValue) : '';
        let howtoplay;
        if (type === 'sudoku') {
          howtoplay = parsedValue ? parsedValue.howtoplaySudoku : '';
        } else if (type === 'location-guesser') {
          if (window?.lwPlayer?.lg) {
            window.lwPlayer.lg.play();
          }
        } else {
          howtoplay = parsedValue ? parsedValue.howtoplay : '';
        }
        if (!howtoplay) {
          storedValue = storedValue ? JSON.parse(storedValue) : {};
          if (type === 'sudoku') {
            storedValue.howtoplaySudoku = true;
            if (isGameIframe && iframeSource) {
              localStorage.setItem(
                `${iframeSource}games`,
                JSON.stringify(storedValue),
              );
            } else {
              localStorage.setItem('toigames', JSON.stringify(storedValue));
            }
            callonContinue('howToPlaySudoku');
          } else {
            storedValue.howtoplay = true;
            window && window.crossword ? (window.crossword.pause = false) : '';
            if (isGameIframe && iframeSource) {
              localStorage.setItem(
                `${iframeSource}games`,
                JSON.stringify(storedValue),
              );
            } else {
              localStorage.setItem('toigames', JSON.stringify(storedValue));
            }
          }
        }
      }
      window && window.crossword && window.crossword.gridInput
        ? window.crossword.gridInput.focus()
        : '';
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
  };

  const openPopup = () => {
    try {
      const body = document.querySelector('body');
      body.classList.add(s.modal_open);
    } catch (err) {
      throw err;
    }
    setOpen(true);
  };

  const fireGa = (ga4Type, ga4Category, ga4Label, gaLabel, event) => {
    const gaData = {
      event: event || 'user_click_games',
      type: ga4Type || '',
      page_template: 'gameplay',
      section: 'games',
      subsection: gameType === 'loopaloop' ? 'loop_the_loop' : gameType,
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: ga4Label,
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ga4Category) {
      gaData.category = ga4Category;
    }
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (gaLabel) {
      gaData.label = gaLabel;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_click_games', gaData);
  };

  useEffect(() => {
    openPopup();
    return () => {
      closePopup();
    };
  }, []);

  useEffect(
    () => {
      if (popUpType === 'typeTwo') {
        fireGa(
          'character_reveal',
          'character_reveal_popup',
          '',
          '',
          'user_shown_games',
        );
      }
    },
    [popUpType],
  );

  useEffect(
    () => {
      if (popUpType === 'errorPopUp') {
        const gaData = {
          event: 'user_shown_games',
          type: 'something_went_wrong',
          label: failedAPI,
          page_template: 'gameplay',
          section: 'games',
          subsection: gameType === 'loopaloop' ? 'loop_the_loop' : gameType,
          browsing_platform: isMobile ? 'mweb' : 'web',
          game_of_the_day: window.location.href
            .toLowerCase()
            .includes('/today'),
          login_status: !!ssoId,
          user_grx_id: grxId,
        };
        if (ssoId) {
          gaData.sso_id = ssoId;
        }
        analyticsWrapper('ga4', gaData);
        analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
      }
    },
    [popUpType],
  );

  const revelCellClosePopup = reveal => {
    const checkbox = document.querySelector('#doNotShowRevealCell');
    const doNotAskAgain = checkbox && checkbox.checked ? checkbox.checked : '';
    if (doNotAskAgain && typeof localStorage !== 'undefined') {
      let toigames;
      if (isGameIframe && iframeSource) {
        toigames = localStorage.getItem(`${iframeSource}games`);
      } else {
        toigames = localStorage.getItem('toigames');
      }
      toigames = toigames ? JSON.parse(toigames) : {};
      toigames.revealCellPopUp = true;
      if (isGameIframe && iframeSource) {
        localStorage.setItem(`${iframeSource}games`, JSON.stringify(toigames));
      } else {
        localStorage.setItem('toigames', JSON.stringify(toigames));
      }
    }
    if (reveal) {
      window?.crossword?.revealCell();
    }
    closePopup();
  };

  const resetPuzzleClosePopup = reset => {
    const checkbox = document.querySelector('#doNotShowReset');
    const doNotAskAgain = checkbox && checkbox.checked ? checkbox.checked : '';
    if (doNotAskAgain && typeof localStorage !== 'undefined') {
      let toigames;
      if (isGameIframe && iframeSource) {
        toigames = localStorage.getItem(`${iframeSource}games`);
      } else {
        toigames = localStorage.getItem('toigames');
      }
      toigames = toigames ? JSON.parse(toigames) : {};
      toigames.resetPopUp = true;
      if (isGameIframe && iframeSource) {
        localStorage.setItem(`${iframeSource}games`, JSON.stringify(toigames));
      } else {
        localStorage.setItem('toigames', JSON.stringify(toigames));
      }
    }
    if (reset) {
      window?.crossword?.resetState();
    }
    closePopup();
  };

  const revelPuzzleClosePopup = () => {
    window?.crossword?.revealAll();
    closePopup();
  };

  const submitClosePopup = () => {
    closePopup();
    window?.crossword?.submitSolutionFinal();
  };

  const restoreStateCallback = () => {
    closePopup();
    if (gameType === 'sudoku') {
      callonContinue('pausegamepopup');
    } else if (window && window.crossword) {
      window.crossword.restoreState();
      window.crossword.pause = false;
    }
  };

  const handleTextBoxChange = event => {
    if (typeof onTextBoxChange === 'function') {
      onTextBoxChange(event?.target?.value || '');
    }
  };

  const submitCallback = data => {
    gameSubmitCallback(data);
    closePopup();
  };

  const mapGaCallback = data => {
    const analyticsParams = {
      event: 'user_click',
      type: data?.type || '',
      category: data?.category || '',
      label: data?.guessCount || '',
      user_grx_id: grxId,
    };
    if (isGameIframe && iframeSource) {
      analyticsParams.business_property = iframeSource;
    }
    analyticsWrapper('ga4', analyticsParams);
  };

  // Belo Code Starts For Calendar View in Popup
  const CALENDAR_ROW_STYLE = {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
    flexWrap: 'nowrap',
  };
  const CALENDAR_DAY_STYLE = {
    flex: '0 0 calc(100% / 7 - 12px)',
  };

  // Helper to render a single day cell
  const renderDayCell = (item, { loading = false } = {}) => {
    if (item == null) {
      // Blank cell (no icon, no number)
      return (
        <div
          key={Math.random()}
          className={`${s.days} ${s.empty}`}
          style={CALENDAR_DAY_STYLE}
        />
      );
    }
    if (loading) {
      return (
        <div
          key={item.id}
          className={`${s.days} ${s.loading}`}
          style={CALENDAR_DAY_STYLE}
        >
          <div className={`${s.calendarIcon} ${s.loading}`}>
            <i className={`${s.puzzleSprite} ${s.gridIcon}`} />
          </div>
          <div className={`${s.dayNumber} ${s.loading}`}>{item.date}</div>
        </div>
      );
    }
    // Actual or disabled day
    return (
      <div
        key={item?.id}
        className={`${s.days} ${item?.hasPlayed ? s.completed : ''} ${
          item?.disabled ? s.disabled : ''
        } ${item && 'hasPlayed' in item ? s.clickable : ''}`}
        style={{
          ...CALENDAR_DAY_STYLE,
          cursor:
            item && 'hasPlayed' in item && !item.disabled
              ? 'pointer'
              : 'default',
          opacity: item?.disabled ? 0.5 : 1,
        }}
        onClick={() => {
          if (item && 'hasPlayed' in item && item.id && !item.disabled) {
            window.location.href = `/games/${gameType}/${item.id}`;
          }
        }}
      >
        <div
          className={[
            s.calendarIcon,
            item.hasPlayed ? s.completed : '',
            gameType,
            item.disabled ? s.disabled : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <i className={`${s.puzzleSprite} ${s.gridIcon}`} />
        </div>
        <div className={s.dayNumber}>{item.date}</div>
      </div>
    );
  };

  // Helper to render a week row
  const renderWeekRow = (week, opts = {}) => (
    <div
      key={week.map(item => item?.id || Math.random()).join('-')}
      style={CALENDAR_ROW_STYLE}
    >
      {week.map(item => renderDayCell(item, opts))}
    </div>
  );

  // Render loading grid
  const renderLoadingGrid = () => {
    const calendarGrid = [];
    for (let weekIndex = 0; weekIndex < 5; weekIndex += 1) {
      const week = [];
      for (let dayIndex = 0; dayIndex < 7; dayIndex += 1) {
        week.push({
          id: `loader-${weekIndex}-${dayIndex}`,
          date: Math.floor(Math.random() * 28) + 1,
        });
      }
      calendarGrid.push(week);
    }
    return calendarGrid.map(week => renderWeekRow(week, { loading: true }));
  };

  // Render empty grid
  const renderEmptyGrid = () => {
    const month = calendarData?.currentMonth || new Date().getMonth() + 1;
    const year = calendarData?.currentYear || new Date().getFullYear();
    const daysInMonth = new Date(year, month, 0).getDate();
    const items = Array.from({ length: daysInMonth }, (_, i) => ({
      id: `disabled-${i + 1}`,
      date: i + 1,
      disabled: true,
    }));
    // Build grid
    const calendarGrid = [];
    let currentWeek = [];
    const jsDate = new Date(year, month - 1, 1);
    const jsDay = jsDate.getDay();
    const startIndex = (jsDay + 6) % 7;
    for (let i = 0; i < startIndex; i += 1) {
      currentWeek.push(null);
    }
    items.forEach(item => {
      currentWeek.push(item);
      if (currentWeek.length === 7) {
        calendarGrid.push([...currentWeek]);
        currentWeek = [];
      }
    });
    if (currentWeek.length > 0) {
      while (currentWeek.length < 7) {
        currentWeek.push(null);
      }
      calendarGrid.push(currentWeek);
    }
    return calendarGrid.map(week => renderWeekRow(week));
  };

  // Render actual calendar grid
  const renderActualGrid = () => {
    const items = calendarData?.items || [];
    const month = calendarData?.currentMonth || new Date().getMonth() + 1;
    const year = calendarData?.currentYear || new Date().getFullYear();
    const daysInMonth = new Date(year, month, 0).getDate();
    const itemsByDate = {};
    items.forEach(item => {
      if (item.date) itemsByDate[item.date] = item;
    });
    const jsDate = new Date(year, month - 1, 1);
    const jsDay = jsDate.getDay();
    const startIndex = (jsDay + 6) % 7;
    const allDays = [];
    for (let i = 1; i <= daysInMonth; i += 1) {
      if (itemsByDate[i]) {
        allDays.push(itemsByDate[i]);
      } else {
        allDays.push({
          id: `disabled-${i}`,
          date: i,
          disabled: true,
        });
      }
    }
    // Build grid
    const calendarGrid = [];
    let currentWeek = [];
    for (let i = 0; i < startIndex; i += 1) {
      currentWeek.push(null);
    }
    allDays.forEach(item => {
      currentWeek.push(item);
      if (currentWeek.length === 7) {
        calendarGrid.push([...currentWeek]);
        currentWeek = [];
      }
    });
    if (currentWeek.length > 0) {
      while (currentWeek.length < 7) {
        currentWeek.push(null);
      }
      calendarGrid.push(currentWeek);
    }
    fireGa(
      'game_practice_widget',
      'game_practice_popup',
      '',
      ``,
      'user_shown_games',
    );
    return calendarGrid.map(week => renderWeekRow(week));
  };

  // Main calendar content render
  const renderCalendarContent = () => {
    if (
      Array.isArray(calendarData?.items) &&
      calendarData.items.length === 4 &&
      calendarData.items[0]?.day?.toUpperCase() === 'MON' &&
      calendarData.items[3]?.day?.toUpperCase() === 'THU'
    ) {
      return null;
    }
    if (showLoader) return renderLoadingGrid();
    if (!calendarData?.items || calendarData.items.length === 0)
      return renderEmptyGrid();
    return renderActualGrid();
  };
  // End of Calendar View in Popup

  const renderPopupContent = () => {
    switch (popUpType) {
      case 'typeOne':
        return (
          <>
            <div className={s.overlayTop}>
              <h2>{gameSpecificTranslations?.overlay?.titles?.howToPlay}</h2>
            </div>
            <div className={s.overlayMid}>
              <HowToPlay gameType={gameType} />
            </div>
            <div className={s.overlayFloatBtn}>
              <button
                onClick={() => {
                  closePopupHowtoPay(gameType);
                  fireGa('continue_playing', 'how_to_play');
                }}
                className={s.btnSecondary}
              >
                {commonTranslations?.overlay?.buttons?.continuePlaying}
              </button>
            </div>
          </>
        );
      case 'howtoplaylg':
        return (
          <>
            <div className={s.overlayTop}>
              <h2>{gameSpecificTranslations?.overlay?.titles?.howToPlay}</h2>
            </div>
            <div className={s.overlayMid}>
              <HowToPlay gameType={gameType} />
            </div>
            <div className={s.overlayFloatBtn}>
              <button
                onClick={() => {
                  closePopupHowtoPay(gameType);
                  fireGa('continue_playing', 'how_to_play');
                }}
                className={s.btnSecondary}
              >
                {commonTranslations?.overlay?.buttons?.continuePlaying}
              </button>
            </div>
          </>
        );
      // case 'leaderboard':
      //   return (
      //     <>
      //       <div className={s.overlayMid}>
      //         <LeaderBoard
      //           wrapperClass="leaderboardPopup"
      //           isOverlay
      //           gameId={gameId}
      //           loaderCallBack={loaderCallBack}
      //         />
      //       </div>
      //     </>
      //   );
      case 'login':
        return (
          <>
            <div className={s.overlayMid}>
              <LoginPrompt
                closePopup={() => {
                  closePopup();
                }}
              />
            </div>
          </>
        );
      case 'loginCloasedGame':
        return (
          <>
            <div className={s.overlayMid}>
              <LoginPrompt
                closePopup={() => {
                  closePopup();
                }}
                loginCloasedGame
              />
            </div>
          </>
        );
      case 'typeTwo':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.revealCharacter}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {gameSpecificTranslations?.messages?.revealCharacterPenalty?.replace(
                    '{penalty}',
                    apiConfigData?.penaltyTimeForCharRevealInSec || 5,
                  )}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    revelCellClosePopup(false);
                    fireGa('continue_playing', 'character_reveal_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    revelCellClosePopup(true);
                    fireGa('reveal_character', 'character_reveal_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.revealCharacter ||
                    'Reveal character'}
                </button>
              </div>
              <div className={s.dontAsk}>
                <label>
                  <input
                    id="doNotShowRevealCell"
                    type="checkbox"
                    checked={isCheckedCW}
                    onChange={() => {
                      setIsCheckedCW(!isCheckedCW);
                    }}
                  />
                  <i />
                  {commonTranslations?.overlay?.labels?.doNotAskMeAgain ||
                    'Do not ask me again'}
                </label>
              </div>
            </div>
          </>
        );
      case 'typeThree':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.resetPuzzle}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {commonTranslations?.overlay?.messages?.resetClearsPuzzle ||
                    'Reset clears the puzzle but does not affect the timer'}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    resetPuzzleClosePopup(false);
                    fireGa('continue_playing', 'game_puzzle_reload_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    resetPuzzleClosePopup(true);
                    fireGa('reset_puzzle', 'game_puzzle_reload_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.resetPuzzle}
                </button>
              </div>
              <div className={s.dontAsk}>
                <label>
                  <input
                    id="doNotShowReset"
                    type="checkbox"
                    checked={isCheckedCWReset}
                    onChange={() => {
                      setIsCheckedCWReset(!isCheckedCWReset);
                    }}
                  />
                  <i />
                  {commonTranslations?.overlay?.labels?.doNotAskMeAgain ||
                    'Do not ask me again'}
                </label>
              </div>
            </div>
          </>
        );
      case 'typeFour':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.revealPuzzle}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {gameSpecificTranslations?.messages?.revealPuzzlePenalty?.replace(
                    '{penalty}',
                    typeof window !== 'undefined' &&
                      window.crossword.revelAllPenalty,
                  )}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    closePopup();
                    fireGa('continue_playing', 'game_reveal_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    revelPuzzleClosePopup();
                    fireGa('reveal', 'game_reveal_popup', 'N/A', '');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.revealPuzzle ||
                    'Reset Puzzle'}
                </button>
              </div>
            </div>
          </>
        );
      case 'typeFive':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.revealPuzzle ||
                    'Are you sure you want to reveal puzzle?'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>{gameSpecificTranslations?.messages?.revealPuzzlePenalty}</p>
              </div>
              <div className={s.btnArea}>
                <button className={s.btnSecondary}>
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
                <div className={s.twoColumn}>
                  <button className={s.btnOutline}>
                    {commonTranslations?.overlay?.buttons?.quit || 'Quit'}
                  </button>
                  <button className={s.btnOutline}>
                    {commonTranslations?.overlay?.buttons?.revealAndSubmit ||
                      'Reveal &amp; Submit'}
                  </button>
                </div>
              </div>
              <div className={s.dontAsk}>
                <label>
                  <input type="checkbox" checked="checked" />
                  <i />
                  {commonTranslations?.overlay?.labels?.doNotAskMeAgain ||
                    'Do not ask me again'}
                </label>
              </div>
            </div>
          </>
        );
      case 'submitConfirmation':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.submitPuzzle ||
                    'Are you sure you want to submit puzzle?'}
                </h2>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    submitClosePopup();
                    fireGa('submit_game', 'submit_popup', '', 'manual_submit');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.yesIWantToSubmit ||
                    'Yes, I want to submit'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    closePopup();
                    fireGa('continue_playing', 'submit_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
              </div>
            </div>
          </>
        );
      case 'errorPopUp':
        return (
          <>
            <div className={s.overlayTop}>
              <h2>
                {commonTranslations?.overlay?.messages?.somethingWentWrong ||
                  'Something went wrong'}
              </h2>
              <div className={s.overlayPara}>
                <p>
                  {commonTranslations?.overlay?.messages?.tryRefreshing ||
                    'Try refreshing the page and check your internet connection'}
                </p>
              </div>
              <div className={s.closeOverlay}>
                <i className={s.iconCross} onClick={closePopup} />
              </div>
            </div>
            <div className={s.overlayMid} />
            <div className={s.overlayBtn}>
              <a href="/games" className={s.btnSecondary}>
                {commonTranslations?.overlay?.buttons?.retry || 'Retry'}
              </a>
            </div>
          </>
        );
      case 'maxGuessExhausted':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {
                    gameSpecificTranslations?.overlay?.titles
                      ?.allGuessesComplete
                  }
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {gameSpecificTranslations?.messages?.guessesExhausted?.replace(
                    '{maxGuessAllowed}',
                    maxGuessAllowed,
                  )}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={`${s.btnSecondary}`}
                  onClick={() => {
                    if (typeof onSubmitLocationGuesser === 'function') {
                      onSubmitLocationGuesser(closePopup);
                    }
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.submit || 'Submit'}
                </button>
              </div>
            </div>
          </>
        );
      case 'perfectPointsGuessed':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.youveNailedIt}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>{gameSpecificTranslations?.messages?.perfectScore}</p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={`${s.btnSecondary}`}
                  onClick={() => {
                    if (typeof onSubmitLocationGuesser === 'function') {
                      onSubmitLocationGuesser(closePopup);
                    }
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.submit || 'Submit'}
                </button>
              </div>
            </div>
          </>
        );
      case 'pausegamepopup':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {commonTranslations?.overlay?.messages?.gameIsPaused ||
                    'Your game is paused'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {commonTranslations?.overlay?.messages
                    ?.wouldYouLikeToContinue ||
                    'Would you like to continue playing?'}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  onClick={restoreStateCallback}
                  className={s.btnSecondary}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
              </div>
            </div>
          </>
        );
      case 'revealCellSudoku':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.revealDigit ||
                    'Are you sure you want to reveal this digit?'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {gameSpecificTranslations?.messages?.revealDigitPenalty?.replace(
                    '{penalty}',
                    typeof window !== 'undefined' && window.penaltyRevelDisplay,
                  )}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    closePopup();
                    fireGa(
                      'continue_playing',
                      'character_reveal_popup',
                      gameLevel,
                    );
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    callonContinue('revealCellSudoku', doNotShowAgain);
                    closePopup();
                    fireGa(
                      'character_reveal',
                      'character_reveal_popup',
                      gameLevel,
                    );
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.revealDigit ||
                    'Reveal Digit'}
                </button>
              </div>
              <div className={s.dontAsk}>
                <label>
                  <input
                    id="doNotShowRevealCell"
                    type="checkbox"
                    onChange={() => {
                      setDoNotShowAgain(!doNotShowAgain);
                    }}
                    checked={doNotShowAgain}
                  />
                  <i />
                  {commonTranslations?.overlay?.labels?.doNotAskMeAgain ||
                    'Do not ask me again'}
                </label>
              </div>
            </div>
          </>
        );
      case 'resetSudoku':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.resetPuzzle ||
                    'Are you sure you want to reset the puzzle?'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {commonTranslations?.overlay?.messages?.resetClearsPuzzle ||
                    'Reset clears the puzzle but does not affect the timer'}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    closePopup();
                    fireGa(
                      'continue_playing',
                      'game_play_again_popup',
                      gameLevel,
                    );
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    callonContinue('resetSudoku', doNotShowReset);
                    closePopup();
                    fireGa('play_again', '', gameLevel);
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.resetPuzzle ||
                    'Reset Puzzle'}
                </button>
              </div>
              <div className={s.dontAsk}>
                <label>
                  <input
                    id="doNotShowReset"
                    type="checkbox"
                    onChange={() => {
                      setDoNotShowReset(!doNotShowReset);
                    }}
                    checked={doNotShowReset}
                  />
                  <i />
                  {commonTranslations?.overlay?.labels?.doNotAskMeAgain ||
                    'Do not ask me again'}
                </label>
              </div>
            </div>
          </>
        );
      case 'resetloopaloop':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.resetPuzzle ||
                    'Are you sure you want to reset the puzzle?'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {commonTranslations?.overlay?.messages?.resetClearsPuzzle ||
                    'Reset clears the puzzle but does not affect the timer'}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    closePopup();
                    fireGa('continue_playing', 'game_puzzle_reload_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    callonContinue('resetloopaloop', doNotShowReset);
                    closePopup();
                    fireGa('restart', 'game');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.resetPuzzle ||
                    'Reset Puzzle'}
                </button>
              </div>
              {!isAppView && (
                <div className={s.dontAsk}>
                  <label>
                    <input
                      id="doNotShowReset"
                      type="checkbox"
                      onChange={() => {
                        setDoNotShowReset(!doNotShowReset);
                      }}
                      checked={doNotShowReset}
                    />
                    <i />
                    {commonTranslations?.overlay?.labels?.doNotAskMeAgain ||
                      'Do not ask me again'}
                  </label>
                </div>
              )}
            </div>
          </>
        );
      case 'resetloopaloopapp':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.resetPuzzle ||
                    'Are you sure you want to reset the puzzle?'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {commonTranslations?.overlay?.messages?.gameWillRestart ||
                    'Your game will restart from the beginning'}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    callonContinue('resetloopaloopapp', doNotShowReset);
                    closePopup();
                    fireGa('restart', 'game');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.reset || 'Reset'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    closePopup();
                    fireGa('continue_playing', 'game_puzzle_reload_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
              </div>
            </div>
          </>
        );
      case 'revealPuzzleSudoku':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.revealPuzzle ||
                    'Are you sure you want to reveal puzzle?'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {gameSpecificTranslations?.messages?.revealPuzzlePenalty?.replace(
                    '{penalty}',
                    typeof window !== 'undefined' &&
                      window.calculatedRevealAllPenalty,
                  )}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    closePopup();
                    fireGa('continue_playing', 'game_reveal_popup', gameLevel);
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    callonContinue('revealPuzzleSudoku');
                    closePopup();
                    fireGa(
                      'reveal',
                      'game_reveal_popup',
                      gameLevel,
                      'manual_submit',
                    );
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.revealPuzzle ||
                    'Reveal Puzzle'}
                </button>
              </div>
            </div>
          </>
        );
      case 'howToPlaySudoku':
        return (
          <>
            <div className={s.overlayTop}>
              <h2>
                {gameSpecificTranslations?.overlay?.titles?.howToPlay ||
                  'How to play sudoku'}
              </h2>
            </div>
            <div className={s.overlayMid}>
              <HowToPlay gameType={gameType} />
            </div>
            <div className={s.overlayFloatBtn}>
              <button
                onClick={() => {
                  fireGa('continue_playing', 'how_to_play', gameLevel);
                  closePopupHowtoPay(gameType);
                }}
                className={s.btnSecondary}
              >
                {commonTranslations?.overlay?.buttons?.continuePlaying ||
                  'Continue Playing'}
              </button>
            </div>
          </>
        );
      case 'howToPlayConnect':
        return (
          <div className={s.howToPlayConnect}>
            <div className={s.overlayTop}>
              <h2>
                {gameSpecificTranslations?.overlay?.titles?.howToPlay ||
                  'How to play Connect'}
              </h2>
            </div>
            <div className={s.overlayMid}>
              <HowToPlay
                gameType={gameType}
                isWebView={isWebView}
                theme={theme}
              />
            </div>
            {!isWebView && (
              <div className={s.overlayFloatBtn}>
                <button
                  onClick={() => {
                    fireGa('continue_playing', 'how_to_play', gameLevel);
                    closePopupHowtoPay(gameType);
                  }}
                  className={s.btnSecondary}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
              </div>
            )}
          </div>
        );
      case 'howToPlayWhoIsThat':
        return (
          <>
            <div className={s.overlayTop}>
              <h2>
                {gameSpecificTranslations?.overlay?.titles?.howToPlay ||
                  'How to play'}
              </h2>
            </div>
            <div className={s.overlayMid}>
              <HowToPlay gameType={gameType} />
            </div>
            <div className={s.overlayFloatBtn}>
              <button
                onClick={() => {
                  closePopupHowtoPay(gameType);
                }}
                className={s.btnSecondary}
              >
                {commonTranslations?.overlay?.buttons?.continuePlaying ||
                  'Continue Playing'}
              </button>
            </div>
          </>
        );
      case 'submitSudoku':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.submitPuzzle ||
                    'Are you sure you want to submit puzzle?'}
                </h2>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    callonContinue('submitConfirmation');
                    closePopup();
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.yesIWantToSubmit ||
                    'Yes, I want to submit'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    closePopup();
                    fireGa('continue_playing', 'submit_popup', gameLevel);
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
              </div>
            </div>
          </>
        );
      case 'submitWhoIsThat':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.submitGame ||
                    'Are you sure want to submit the game?'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {gameSpecificTranslations?.overlay?.messages
                    ?.unattemptedPlayersZero ||
                    `Scores for all unattempted players will be calculated as zero in the total score.`}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    callonContinue('submitConfirmation');
                    closePopup();
                    fireGa('submit', 'game_submit_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.iWantToSubmit ||
                    'I want to submit'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    closePopup();
                    fireGa('continue_playing', 'game_submit_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
              </div>
            </div>
          </>
        );
      case 'setUserName':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {commonTranslations?.overlay?.labels?.updateYourName ||
                    'Update your name'}
                </h2>
              </div>
              <div className={s.textInput}>
                <label htmlFor="userName">
                  {commonTranslations?.overlay?.labels?.enterYourName ||
                    'Enter your name'}
                </label>
                <input
                  type="text"
                  id="userName"
                  value={textValue}
                  onChange={handleTextBoxChange}
                  aria-label="Enter your name"
                />
              </div>
              <div className={s.btnArea}>
                <button
                  className={`${s.btnSecondary} ${
                    typeof textValue === 'string' && textValue.trim()
                      ? ''
                      : s.disabled
                  }`}
                  onClick={() => {
                    if (typeof onTextBoxSubmit === 'function') {
                      onTextBoxSubmit(closePopup);
                    }
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.update || 'Update'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    closePopup('editProfileSkip');
                    handleTextBoxChange('');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.skipForNow ||
                    'Skip for now'}
                </button>
              </div>
            </div>
          </>
        );
      case 'lgMap':
        return (
          <>
            <div className={s.overlayTop}>
              <Map
                mapData={mapData}
                submitCallback={submitCallback}
                submitGuessCallback={submitGuessCallback}
                isWebView
                maxGuessAllowed={maxGuessAllowed}
                isMobile={isMobile}
                errorCallback={errorCallback}
                gaCallback={mapGaCallback}
                gameId={gameId}
              />
            </div>
          </>
        );
      case 'revealWhoIsThat':
        return (
          <>
            <div className={s.overlayMid}>
              <div className={s.overlayTitle}>
                <h2>
                  {gameSpecificTranslations?.overlay?.titles?.revealAnswer ||
                    'Are you sure you want to reveal the answer?'}
                </h2>
              </div>
              <div className={s.overlayPara}>
                <p>
                  {gameSpecificTranslations?.overlay?.messages
                    ?.revealAnswerZeroPoints ||
                    `Revealing the answer will result in 0 points for this player.`}
                </p>
              </div>
              <div className={s.btnArea}>
                <button
                  className={s.btnSecondary}
                  onClick={() => {
                    closePopup();
                    fireGa('continue_playing', 'game_character_reveal_popup');
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.continuePlaying ||
                    'Continue Playing'}
                </button>
                <button
                  className={s.btnText}
                  onClick={() => {
                    callonContinue('revealCellWhoIsThat', doNotShowAgain);
                    closePopup();
                  }}
                >
                  {commonTranslations?.overlay?.buttons?.revealAnswer ||
                    'Reveal Answer'}
                </button>
              </div>
              <div className={s.dontAsk}>
                <label>
                  <input
                    id="doNotShowRevealCell"
                    type="checkbox"
                    onChange={() => {
                      setDoNotShowAgain(!doNotShowAgain);
                    }}
                    checked={doNotShowAgain}
                  />
                  <i />
                  {commonTranslations?.overlay?.labels?.doNotAskMeAgain ||
                    'Do not ask me again'}
                </label>
              </div>
            </div>
          </>
        );
      case 'calendar':
        return (
          <div className={`${s.calendarPopup} ${s.innerPopup}`}>
            <div
              className={`${s.popupHeader} ${gameType ? `${gameType}` : ''}`}
              style={{
                backgroundColor: calendarData?.backgroundColor || '#fff',
              }}
            >
              <div className={s.gameTitleWrap}>
                <div className={s.leftArea}>
                  <img
                    src={
                      calendarData?.gameIcon || '/assets/images/cross-logo.png'
                    }
                    alt="CROSS"
                    className="logo"
                  />
                </div>
                <div className={s.rightArea}>
                  <strong>{calendarData?.gameName || ''}</strong>
                  <span>Previous Puzzles</span>
                  {/* <button className={s.closeBtn} onClick={closePopup}>
                    &times;
                  </button> */}
                </div>
              </div>

              <div className={s.gameLevel}>
                {calendarData?.playMoreData?.levelNameList?.map(
                  (level, index) => {
                    const isActive =
                      level.toLowerCase() === calendarData?.currentLevel;
                    return (
                      <button
                        key={index}
                        className={`${s.levelBtn} ${isActive ? s.active : ''}`}
                        onClick={() => {
                          if (typeof onLevelChange === 'function') {
                            onLevelChange(level.toLowerCase());
                          }
                        }}
                      >
                        <span>{level}</span>
                      </button>
                    );
                  },
                )}
              </div>
            </div>
            <div className={s.calendarContent}>
              <div className={s.calendarNav}>
                <div
                  className={`${s.arrow} ${
                    isPreviousDisabled() ? s.disabled : ''
                  }`}
                  onClick={
                    !isPreviousDisabled() ? handlePreviousMonth : undefined
                  }
                >
                  {' '}
                  <i className={`${s.puzzleSprite} ${s.leftArrow}`} />
                </div>
                <span className={s.month}>
                  {calendarData?.monthYearDisplay || ''}
                </span>
                <div
                  className={`${s.arrow} ${isNextDisabled() ? s.disabled : ''}`}
                  onClick={!isNextDisabled() ? handleNextMonth : undefined}
                >
                  {' '}
                  <i className={`${s.puzzleSprite} ${s.rightArrow}`} />
                </div>
              </div>
              <div className={s.calendarGrid}>
                <div className={s.dayHeader}>
                  <div className={s.dayName}>MON</div>
                  <div className={s.dayName}>TUE</div>
                  <div className={s.dayName}>WED</div>
                  <div className={s.dayName}>THU</div>
                  <div className={s.dayName}>FRI</div>
                  <div className={s.dayName}>SAT</div>
                  <div className={s.dayName}>SUN</div>
                </div>
                <div
                  className={s.daysContainer}
                  style={{ display: 'block', flexWrap: 'nowrap' }}
                >
                  {renderCalendarContent()}
                </div>
              </div>
            </div>
          </div>
        );
      case 'non-logged-in-calendar':
        return (
          <div
            className={`${s.calendarPopup} ${s.innerPopup} ${
              s.nonLoggedInCalendar
            }`}
          >
            <div
              className={`${s.popupHeader} ${gameType ? `${gameType}` : ''}`}
            >
              <div className={s.gameTitleWrap}>
                <div className={s.leftArea}>
                  <img
                    src={
                      calendarData?.gameIcon || '/assets/images/cross-logo.png'
                    }
                    alt="CROSS"
                    className="logo"
                  />
                </div>
                <div className={s.rightArea}>
                  <strong>{calendarData?.gameName || ''}</strong>
                  <span>Previous Puzzles</span>
                  {/* <button className={s.closeBtn} onClick={closePopup}>
                    &times;
                  </button> */}
                </div>
              </div>
            </div>
            <div className={s.loginErrorContainer}>
              <div className={s.loginError}>
                <figure>
                  <img
                    src={`${TOI_IMAGE_DOMAIN}/photo/122060409.cms`}
                    alt="error vector"
                  />
                </figure>
                <div className={s.error}>
                  <strong>Looks like you are not logged in!</strong>
                  <span>
                    Log in to check and unlock the practice puzzles available
                    for you
                  </span>
                  <button
                    className={s.btnPrimary}
                    onClick={() => {
                      fireGa(
                        'game_practice_widget',
                        'game_practice_popup',
                        '',
                        ``,
                        'user_click_games',
                      );
                      openLoginBox();
                    }}
                  >
                    Log in
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      case 'gamesolution':
        return (
          <div className={`${s.resultPopup} ${s.innerPopup}`}>
            <div
              className={`${s.popupHeader} ${gameType ? `${gameType}` : ''}`}
            >
              <div className={s.gameTitleWrap}>
                <strong>Result view</strong>
              </div>
            </div>
            <GameSolution
              buttonClicked={buttonClicked}
              isMobile={isMobile}
              gameId={gameId}
              gameType={gameType}
              showLoader={showLoader}
              gameLevel={gameLevel}
              gamejsonUrl={gamejsonUrl}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className={`${s.overlayWrap} ${
            popUpType === 'leaderboard' ? s.overlayDark : ''
          }
          ${
            popUpType === 'typeOne' ||
            popUpType === 'howToPlaySudoku' ||
            popUpType === 'howtoplaylg' ||
            popUpType === 'howToPlayWhoIsThat' ||
            popUpType === 'howToPlayConnect'
              ? s.gameInstruction
              : ''
          } ${isLoading ? s.noData : ''}
          ${popUpType === 'lgMap' ? s.mapOverlay : ''}`}
        >
          <div className={`${s.overlayContent}`}>
            {/* {popUpType !== 'loginCloasedGame' && ( */}
            <div className={s.closeOverlay}>
              {popUpType !== 'maxGuessExhausted' &&
                popUpType !== 'perfectPointsGuessed' && (
                  <i
                    className={`${s.icon} ${s.iconCross}`}
                    onClick={() => {
                      if (
                        popUpType === 'typeOne' ||
                        popUpType === 'howToPlaySudoku' ||
                        popUpType === 'howtoplaylg'
                      ) {
                        closePopupHowtoPay(gameType);
                        fireGa('continue_playing', 'how_to_play');
                      } else if (popUpType === 'pausegamepopup') {
                        restoreStateCallback();
                      } else {
                        closePopup();
                        if (popUpType === 'typeTwo') {
                          fireGa('continue_playing', 'character_reveal_popup');
                        } else if (popUpType === 'revealCellSudoku') {
                          fireGa(
                            'continue_playing',
                            'character_reveal_popup',
                            gameLevel,
                          );
                        } else if (popUpType === 'typeThree') {
                          fireGa(
                            'continue_playing',
                            'game_puzzle_reload_popup',
                          );
                        } else if (popUpType === 'resetSudoku') {
                          fireGa(
                            'continue_playing',
                            'game_puzzle_reload_popup',
                            gameLevel,
                          );
                        } else if (popUpType === 'typeFour') {
                          fireGa(
                            'continue_playing',
                            'game_puzzle_reveal_popup',
                          );
                        } else if (popUpType === 'revealPuzzleSudoku') {
                          fireGa(
                            'continue_playing',
                            'game_puzzle_reveal_popup',
                            gameLevel,
                          );
                        } else if (popUpType === 'lgMap') {
                          fireGa('map_screen_close', 'game');
                        } else if (popUpType === 'submitConfirmation') {
                          fireGa('continue_playing', 'submit_popup');
                        } else if (popUpType === 'submitSudoku') {
                          fireGa('continue_playing', 'submit_popup', gameLevel);
                        }
                      }
                    }}
                  />
                )}
            </div>
            {/* )} */}
            {renderPopupContent()}
          </div>
        </div>
      )}
    </>
  );
};

export default GameOverlay;
